import baseApp from './../innerAPP'
import './../css/home.css'
import App from './App'

;(async () => {
  const vm = await baseApp(App)
  vm.mount('#app')
})()
